<template>
  <div
    id="phone-container"
    aria-hidden="true"
  >
    <div id="phone-border">
      <div
        id="phone-header"
        :style="`background-color: ${primaryColor}`"
      >
        <div id="menu-container">
          <div />
          <div />
          <div />
        </div>
      </div>
      <div
        id="phone-content-wrapper"
        class="sn-font-primary"
      >
        <div id="phone-logo">
          <img :src="servicerImageUrl">
        </div>
        <div id="phone-content">
          <div>
            <h3>
              My Tasks
            </h3>
          </div>
          <ul>
            <li>
              <v-icon
                class="icon"
                :color="iconColor"
              >
                sn-icon-upload
              </v-icon>
              <div class="list-item-text">
                <h4>Drivers License</h4>
                <p>Needs to be uploaded</p>
              </div>
              <div class="spacer" />
              <v-icon
                class="icon"
                :color="iconColor"
              >
                sn-icon-chevron-right-small
              </v-icon>
            </li>
            <li>
              <v-icon
                class="icon"
                :color="iconColor"
              >
                sn-icon-upload
              </v-icon>
              <div class="list-item-text">
                <h4>Bank Statements</h4>
                <p>Need to be uploaded</p>
              </div>
              <div class="spacer" />
              <v-icon
                class="icon"
                :color="iconColor"
              >
                sn-icon-chevron-right-small
              </v-icon>
            </li>
            <li>
              <v-icon
                class="icon"
                :color="iconColor"
              >
                sn-icon-upload
              </v-icon>
              <div class="list-item-text">
                <h4>Tax Returns</h4>
                <p>Need to be uploaded</p>
              </div>
              <div class="spacer" />
              <v-icon
                class="icon"
                :color="iconColor"
              >
                sn-icon-chevron-right-small
              </v-icon>
            </li>
            <li>
              <v-icon
                class="icon"
                :color="iconColor"
              >
                sn-icon-upload
              </v-icon>
              <div class="list-item-text">
                <h4>W2 Forms</h4>
                <p>Need to be uploaded</p>
              </div>
              <div class="spacer" />
              <v-icon
                class="icon"
                :color="iconColor"
              >
                sn-icon-chevron-right-small
              </v-icon>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PhoneMock',
  props: {
    servicer: {
      type: Object,
      required: true,
      default: () => { return {} }
    }
  },
  computed: {
    servicerImageUrl () {
      return this.servicer.profile_image_url
    },
    companyLogoURL () {
      return this.servicer.effective_company_logo_url || 'https://simplenexus.com/images/profile_sihlouette.png'
    },
    primaryColor () {
      return this.$vuetify.theme.themes.light.primary
    },
    iconColor () {
      return '#7F7F7F'
    }
  }
}
</script>

<style scoped lang="scss">
@import '~/assets/css/snui';

ul, p {
  padding: 0;
  margin: 0;
}

li {
  display: flex;
  align-items: center;
  justify-items: center;
  margin-top: 12px;
  padding: 26px 18px 26px 14px;
  box-shadow: $sn-shadow-depth-1;
  border-radius: 4px;
}

#phone-container {
  position: relative;
  display: flex;
  width: 368px;
  min-width: 368px;
  min-height: 575px;
  height: 100%;
  color: #888;
  border-radius: 22px;
}

#phone-border {
  width: 100%;
  height: 100%;
  border: 8px solid #FFFFFF;
  box-shadow: $sn-shadow-depth-4;
  border-radius: 22px;
}

#phone-header {
  background-color: #0092BF;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  height: 142px;
}

#menu-container {
  width: 47px;
  height: 47px;
  padding-left: 21px;
  padding-top: 16px;
}

#menu-container div {
  width: 18px;
  height: 1px;
  margin-top: 6px;
  background-color: white;
}

#phone-logo {
  width: 80px;
  height: 80px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  margin-top: -40px;
  margin-bottom: 28px;
  overflow: hidden;
  z-index: 1;
  border-radius: 50%;
  background-color: white;
  box-shadow: $sn-shadow-depth-1;
}

#phone-logo img {
  width: 100%;
}

#phone-logo-title {
  text-align: center;
  margin: auto;
  padding-top: 28px;
}

#phone-content-wrapper {
  margin-top: -16px;
  clip-path: inset(-80px 0 0 0);
  position: relative;
}

#phone-content {
  padding: 67px 9px 0 9px;
  color: black;
  background-color: white;
  border-radius: 16px 16px 0 0;
  box-shadow: 0px -7px 12px rgba(31, 31, 31, 0.1), 0px -8px 16px rgba(31, 31, 31, 0.08), 0px -9px 18px rgba(31, 31, 31, 0.08);
}

#phone-content h3 {
  font-weight: $font-weight-semi-bold;
  font-size: 22px;
  line-height: 32px;
  color: black;
}

.icon {
  padding: 5px;
  border: 1px solid;
  border-radius: 50%;
}

.list-item-text {
  justify-self: start;
  margin: 0 15px;
}

.list-item-text h4 {
  font-weight: $font-weight-bold;
  font-size: 17px;
  line-height: 24px;
  color: $sn-primary-02;
}

.list-item-text p {
  margin-top: 4px;
  font-weight: $font-weight-regular;
  font-size: 13px;
  line-height: 18px;
  color: $sn-primary-01;
}

.spacer {
  flex: 1;
}

</style>
